import { API } from "../../../utils/Apis";
import { AppDispatch } from "../Store";

import {
  createVenueSpace,
  deleteVenueSpace,
  getSearchSpaces,
  getVenueSpaces,
  updateVenueSpace,
} from "../Reducers/SpaceReducers";
import {
  getFavorites,
  getFavoritesList,
  updateFavorites,
} from "../Reducers/AuthReducers";

export const createSpaceAction = (data: object, dispatch: AppDispatch) =>
  API.createNewSpace(data).then((res) => {
    if (res.type === "success") {
      dispatch(createVenueSpace({ item: res.data }));
    }

    return res;
  });

export const updateSpaceAction = (data: object, dispatch: AppDispatch) =>
  API.updateSpace(data).then((res) => {
    if (res.type === "success") {
      dispatch(updateVenueSpace({ item: res.data }));
    }

    return res;
  });

export const deleteSpaceAction = (
  data: { id?: string } & object,
  dispatch: AppDispatch
) =>
  API.deleteSpace(data).then((res) => {
    if (res.type === "success") {
      // The delete endpoint returns only { type, message } (no data), so use
      // the id we sent in the request rather than res.data.id (which is
      // undefined and threw "Cannot read properties of undefined (reading 'id')").
      const deletedId = res?.data?.id ?? data.id;
      dispatch(deleteVenueSpace({ id: deletedId }));
    }

    return res;
  });

export const getSearchSpacesAction = (data: object, dispatch: AppDispatch) =>
  API.getSearchSpace(data).then((res) => {
    if (res.type === "success") {
      const updateList = data.page === 1 || data.page === "1";
      dispatch(getSearchSpaces({ items: res.data, updateList }));
    }

    return res;
  });

export const getVenueSpacesAction = (data: object, dispatch: AppDispatch) =>
  API.getVenueSpaceList(data).then((res) => {
    if (res.type === "success") {
      let updateList = false;

      if (data?.page === "1") {
        updateList = true;
      }

      dispatch(getVenueSpaces({ items: res.data, updateList }));
    }

    return res;
  });

export const getUserFavoritesListAction = (
  data: object,
  dispatch: AppDispatch
) =>
  API.getUserFavoritesList(data).then((res) => {
    if (res.type === "success") {
      const favorites = res.data ? res.data : [];
      dispatch(getFavoritesList({ items: favorites }));
    }

    return res;
  });

export const getUserFavoritesAction = (dispatch: AppDispatch) =>
  API.getUserFavorites().then((res) => {
    if (res.type === "success") {
      const favorites = res.data ? res.data : [];
      dispatch(getFavorites({ items: favorites }));
    }

    return res;
  });

export const toggleFavoriteAction = (data: object, dispatch: AppDispatch) =>
  API.toggleUserFavorite(data).then((res) => {
    if (res.type === "success") {
      dispatch(updateFavorites({ id: data.spaceId }));
    }

    return res;
  });
